"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef, createElement } from "react";
import { cardsRecipe } from "./cards.css.js";
import { LoadingSkeleton } from "./SharedComponents.js";
const LinkCard = forwardRef(function LinkCard2({ $as, as, children, isLoading, density, ...props }, ref) {
  const cardProps = {
    ...props,
    ref,
    className: classNames(cardsRecipe({
      type: "link",
      isLoading,
      density
    }), props.className)
  };
  return createElement($as ?? as ?? "a", cardProps, jsx(Fragment, { children: isLoading ? jsx(LoadingSkeleton, {}) : children }));
});
export {
  LinkCard
};
